import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Web Vitals disabled temporarily due to import issues
// TODO: Re-enable once import issues are resolved

// Error handling
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Create root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hot Module Replacement
if (import.meta.hot) {
  import.meta.hot.accept();
}